/* MCListMessageRenderer: The default message render's logic is encapsulated in this class. */

import WidgetTypes from '../core/enums/WidgetTypes';
import questionTypeMultipleChoiceAsListOptionsTemplate from '../templates/question_types/multiple_choice_display_as_list_options_template.ejs';
import ImportMCListTemplateFactory from './ImportFactories/ImportMCListTemplateFactory';
import QTMessageRenderer from './QTMessageRenderer';

export default class MCListMessageRenderer extends QTMessageRenderer {
    constructor(options) {
        super(options);
        const me = this;
        me.model = options.msg;
        if (!me.listOptions) {
            // check if listoptions is not exists then get from the options
            me.listOptions = ApexChat.TryParse(me.model.options || me.model.answerScript?.options || me.options);
            if (me.listOptions) {
                me.listOptions.forEach((item) => {
                    if (item.option.includes('href')) {
                        const el = document.createElement('div');
                        el.innerHTML = item.option;
                        const url = el.querySelector('a')?.getAttribute('href');
                        item.option = item.option.replace('<a', `<a title='${url}'`);
                    }
                });
            }
        }
        const msg = options?.message ?? options.msg;
        if (msg && !msg?.handlerImageUrl && me.options.widgetType == WidgetTypes.ExitPopup) {
            msg.handlerImageUrl = me.options?.model?.handlerImageUrl;
        }

        me.template = ImportMCListTemplateFactory(
            me.options
        ).questionTypeMultipleChoiceAsListTemplate(options.msg);
    }

    render() {
        const me = this;
        super.render();
        const selectOptions = me.getItems();
        me.wrapper.innerHTML = selectOptions
            ? me.template.replace('apexchat_options_div', selectOptions)
            : me.template;
        me.container.appendChild(me.wrapper);
        me.afterRender();
    }

    getItems() {
        const me = this;
        let optionsHTML = '';
        // Select template for new options list
        const dropDownListOptionTemplate = questionTypeMultipleChoiceAsListOptionsTemplate;
        for (let i = 0; i < me.listOptions.length; i++) {
            optionsHTML += dropDownListOptionTemplate({
                name: me.listOptions[i].option
            });
        }
        return optionsHTML;
    }

    getSelectedValue() {
        const me = this;
        const elementRDSelectedItem = me.$(
            `#apexchat_question_type_multiple_choice_as_list_select_control_${me.model.id} .selected`,
            me.context
        );
        if (elementRDSelectedItem.text() !== '') {
            return elementRDSelectedItem.text();
        }
        const elementNonRDSelectedItem = me.$(
            `#apexchat_question_type_multiple_choice_as_list_select_control_${me.model.id}`,
            me.context
        );
        if (elementNonRDSelectedItem.val()) {
            return elementNonRDSelectedItem.val().trim();
        }
        return null;
    }

    afterRender() {
        const me = this;
        me.$(`#livechat_bottomsheet_wrapper_${me.model.id}`, me.context).css('display', 'block');
        me.displaySkipOption();
    }
}
